import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/app/(main)/embed-emission-calculations/pageBody.tsx");
